package com.milta.core.localization.translations.bg

import com.milta.core.localization.AuthStrings

internal val Auth = AuthStrings(
    login = "Вход",
    logout = "Изход",
    email = "Имейл",
    password = "Парола",
    showPassword = "Покажи",
    hidePassword = "Скрий",
    roleSelectionTitle = "Създайте акаунт",
    roleSelectionSubtitle = "Изберете типа акаунт, който отговаря на вашия профил",
    roleDriverTitle = "Аз съм шофьор - доставчик",
    roleDriverDescription = "Карам превозно средство за транспорт или доставка и искам да оптимизирам маршрутите си",
    roleDriverTag1 = "Оптимизиране на маршрути",
    roleDriverTag2 = "Оферти Milta по моя маршрут",
    roleEnterpriseTitle = "Аз съм компания",
    roleEnterpriseDescription = "Имам ДДС номер и управлявам флота от превозни средства и екип от шофьори",
    roleEnterpriseTag1 = "Управление на флота",
    roleEnterpriseTag2 = "Проследяване на екипи",
    continueButton = "Продължете",
    registerFormTitle = "Завършете регистрацията",
    registerFormSubtitle = "Потвърдете телефонния си номер, за да активирате акаунта си.",
    registerFormSubtitleEnterprise = "Въведете организацията си и телефонен номер, за да активирате акаунта си.",
    googleAccountConnected = "Профилът в Google е свързан",
    appleAccountConnected = "Профилът в Apple е свързан",
    firstName = "Собствено име",
    lastName = "Фамилия",
    phoneNumber = "Телефонен номер",
    phoneNumberHelper = "Въведете телефонния номер по избор.",
    phoneNumberOtpInfo = "Код за потвърждение ще бъде изпратен по SMS, за да потвърдите този номер.",
    registerButton = "Получете код за потвърждение",
    passwordHint = "Поне 8 символа",
    registerSuccess = "Акаунтът е създаден успешно",
    errorEmailConflict = "Този имейл адрес вече се използва",
    errorPhoneConflict = "Този телефонен номер вече е регистриран",
    errorGeneric = "Връзката не успя. Проверете мрежата и опитайте отново.",
    errorFirstNameRequired = "Моля, въведете собственото си име",
    errorFirstNameTooLong = "Собственото име не може да надвишава 100 символа",
    errorLastNameRequired = "Моля, въведете фамилията си",
    errorLastNameTooLong = "Фамилията не може да надвишава 100 символа",
    errorPhoneTooLong = "Телефонният номер не може да надвишава 20 символа",
    errorOAuthAccountExists = "Този акаунт вече е свързан с друг акаунт в Milta. Опитайте да влезете.",
    errorOAuthTokenInvalid = "Сесията ви е изтекла. Моля, влезте отново.",
    loginTitle = "Вход",
    loginTabPassword = "Парола",
    loginTabPhone = "Телефон",
    loginButton = "Влезте",
    forgotPassword = "Забравена парола?",
    sendCodeButton = "Изпрати код",
    otpTitle = "Въведете кода",
    otpSubtitle = "Изпратихме 6-цифрен код на",
    otpVerifyButton = "Потвърди",
    otpResend = "Изпрати отново",
    otpResendPrefix = "Не получихте код?",
    otpWrongNumber = "Грешен номер?",
    otpModifyLink = "Промени",
    forgotPasswordTitle = "Забравена парола",
    forgotPasswordSubtitle = "Въведете имейл адреса си за нулиране",
    forgotPasswordButton = "Изпрати линк",
    forgotPasswordSuccess = "Проверете пощата си",
    resetPasswordTitle = "Нова парола",
    resetPasswordSubtitle = "Изберете нова парола за вашия акаунт",
    resetPasswordNewLabel = "Нова парола",
    resetPasswordConfirmLabel = "Потвърдете паролата",
    resetPasswordButton = "Нулиране на паролата",
    resetPasswordSuccess = "Паролата е нулирана. Вече можете да влезете.",
    errorPasswordTooShort = "Паролата трябва да съдържа поне 8 символа",
    errorPasswordTooLong = "Паролата не може да надвишава 128 символа",
    errorPasswordMismatch = "Паролите не съвпадат",
    errorTokenInvalid = "Този линк за нулиране е невалиден или е изтекъл. Поискайте нов.",
    errorEmailInvalid = "Моля въведете валиден имейл адрес",
    errorPhoneRequired = "Моля въведете телефонен номер",
    errorInvalidCredentials = "Грешен имейл или парола. Използвайте 'Забравена парола?' ако е необходимо.",
    errorInvalidOtp = "Грешен код. Проверете SMS-а или поискайте нов.",
    errorExpiredOtp = "Кодът изтече. Поискайте нов.",
    errorTooManyAttempts = "Твърде много грешни опити. Опитайте след няколко минути.",
    errorResendLimit = "Твърде много заявки за повторно изпращане. Опитайте след няколко минути.",
    otpResendIn = "Изпрати отново след %d с",
    otpAttemptsLeft = "Остават %d опита",
    loginGreeting = "Добре дошли обратно!",
    loginSubtitle = "Влезте в своя акаунт Milta",
    loginSmsOption = "Получете SMS код",
    noAccount = "Нямате акаунт?",
    signUp = "Регистрирай се",
    organizationName = "Наименование на организацията",
    organizationNameRequired = "Моля, въведете наименованието на организацията",
    registerNextButton = "Напред",
    passwordConfirm = "Потвърди паролата",
    passwordRuleUpper = "Една главна буква",
    passwordRuleDigit = "Една цифра",
    passwordRuleSpecial = "Един специален знак",
    alreadyHaveAccount = "Вече имате акаунт — Влезте",
)
